angular.module("listiniOps.components", []).component("listiniOps", {
  templateUrl: "ng/components/listiniOps/listiniOps.html",
  bindings: {
    configSearch: "<",
    vendorManag: "<",
    gestioneFornitori: "<",
    appCustomer: "<",
    vendorNdg: "<",
    listiniEconomici: "<",
  },
  controller: listiniOpsController,
  controllerAs: "listiniOpsCtrl",
});

function listiniOpsController(
  $simulationService,
  $modalService,
  $rootScope,
  $scope
) {
  var self = this;

  self.$onInit = function () {
    self.priceListLoading = true;
    self.addPriceListMode = false;
    self.defaults = {
      band: {
        costiFissiPerc: null,
        costoAssPerc: null,
        dettagli: null,
        massimo: 10000,
        minimo: 1500,
        numeroFascia: 1,
        provvigioniFornitore: 0,
        spese: 0,
      },
      durations: [
        { durata: 18, selected: false, tan: null, vr: null },
        { durata: 24, selected: false, tan: null, vr: null },
        { durata: 30, selected: false, tan: null, vr: null },
        { durata: 36, selected: false, tan: null, vr: null },
        { durata: 42, selected: false, tan: null, vr: null },
        { durata: 48, selected: false, tan: null, vr: null },
        { durata: 60, selected: false, tan: null, vr: null },
        { durata: 72, selected: false, tan: null, vr: null },
        { durata: 84, selected: false, tan: null, vr: null },
        { durata: 96, selected: false, tan: null, vr: null },
      ],
      associablePriceLists: [],
    };
    (self.inputs = {
      bandDetail: {
        min: 0,
        max: 0,
        commissions: 0,
        expenses: 0,
        fixedCosts: 0,
        insuranceCosts: 0,
        financialParamsPerDuration: [],
      },
      globalPriceListConfig: {
        irs: 0,
      },
    }),
      //NUOVO listino

      (self.priceListBands = []);
    self.arrayOfDurations = [];
    self.newListino = {
      nameListino: null,
      ndgListino: null,
      selectedDurations: [],
    };
    // SCEGLI LISTNIO
    self.priceListsDropdown = [];
    self.listinoSelected = {
      priceListSelected: null,
      durationsSelected: [],
    };
    self.getPriceListsOps(true);
  };

  self.getPriceListsOps = function (onInit) {
    $simulationService
      .getPriceListsOps(self.vendorNdg)
      .then(function (response) {
        if (response.success) {
          console.log("getPriceListsOps: ", response);
          if (response.listListino && response.listListino.length) {
            self.priceListsDropdown = response.listListino.filter(function (
              priceList
            ) {
              return priceList.ndg == self.vendorNdg;
            });
            console.log("self.priceListsDropdown", self.priceListsDropdown);
            self.defaults.associablePriceLists = response.listListino.filter(
              function (priceList) {
                return (
                  (priceList.ndg != null && priceList.ndg == self.vendorNdg) ||
                  priceList.ndg == null
                );
              }
            );
          }
        }
        self.priceListLoading = false;
      })
      .catch(function (error) {
        console.log("ERROR", error);
        self.priceListLoading = false;
      });
  };

  self.addPriceList = function () {
    if (self.priceListBands.length) {
      self.priceListBands = [];
    }
    self.listinoSelected.priceListSelected = null;
    self.listinoSelected.durationsSelected = [];
    self.addPriceListMode = true;
    self.copiedDefaults = Object.assign({}, self.defaults.band);
    self.priceListBands.push(self.copiedDefaults);
  };

  self.handleChanges = function (value, mode) {
    switch (mode) {
      case "addMode":
        if (self.listinoSelected && self.newListino.ndgListino) {
          var priceListExists = checkIfPriceListExisting();
          if (priceListExists) {
            $modalService.openModal("priceListAlreadyExistsModal");
          } else {
            var priceListExistButNotAssociated = checkIfPriceListAssociable(
              self.newListino.ndgListino
            );
            if (priceListExistButNotAssociated) {
              $modalService.openModal("priceListAssociableModal");
            }
          }
          self.getPriceListDurations(self.newListino.ndgListino);
        }
        break;
      case "selectMode":
        if (value && value.id) {
          var priceListExistButNotAssociated = checkIfPriceListAssociable(
            value.id
          );
          if (priceListExistButNotAssociated) {
            $modalService.openModal("priceListAssociableModal");
          }
        }
        if (
          !self.listinoSelected.priceListSelected ||
          !Object.keys(self.listinoSelected.priceListSelected).length ||
          !self.listinoSelected.priceListSelected.id
        ) {
          self.priceListBands = [];
          self.cleanMultiSelect();
          self.getPriceListsOps();
        } else {
          self.getPriceListsOps();
          self.getPriceListBands();
          self.getPriceListDurations(value.id);
        }
        break;
    }
  };

  self.checkFields = function () {
    var details = self.inputs.bandDetail.financialParamsPerDuration.every(
      function (x) {
        return x.vrPerc && x.tanPerc;
      }
    );
    // To check if modified fields are present in a band and give evidence of that
    if (
      self.inputs.bandDetail.min &&
      self.inputs.bandDetail.max &&
      self.inputs.bandDetail.commissions &&
      self.inputs.bandDetail.expenses &&
      details
    ) {
      self.checkFieldsOfBand = true;
    } else {
      self.checkFieldsOfBand = false;
    }
  };

  self.getPriceListBands = function () {
    if (
      self.listinoSelected.priceListSelected &&
      self.listinoSelected.priceListSelected.id
    ) {
      self.isLoadingPriceListTable = true;
      var priceListNdg = self.listinoSelected.priceListSelected.id;
      $simulationService
        .getPriceListBands(priceListNdg)
        .then(function (response) {
          if (response) {
            console.log("Response getPriceListBands: ", response);
            self.priceListBands = response.fascieListino;
            self.priceListBands.forEach(function (priceListBand) {
              priceListBand.provvigioniFornitore =
                priceListBand.provvigioniFornitore * 100;
            });
          }
        })
        .catch(function (error) {
          console.log("ERROR", error);
          self.isLoadingPriceListTable = false;
        })
        .finally(function () {
          console.log("Gone!");
          self.isLoadingPriceListTable = false;
        });
    } else {
      self.priceListBands = [];
    }
  };

  self.cleanMultiSelect = function () {
    self.listinoSelected.durationsSelected = [];
    self.listinoSelected.priceListSelected = null;
  };

  var checkIfPriceListExisting = function () {
    if (self.priceListsDropdown.length) {
      return self.priceListsDropdown.some(function (priceList) {
        return (
          priceList.id == self.newListino.ndgListino &&
          priceList.ndg == self.vendorNdg
        );
      });
    }
  };

  var checkIfPriceListAssociable = function (ndg) {
    if (self.defaults.associablePriceLists.length) {
      return self.defaults.associablePriceLists.some(function (priceList) {
        return priceList.id == ndg && priceList.ndg != self.vendorNdg;
      });
    }
  };

  self.getPriceListDurations = function (ndg) {
    console.log("ndgListino", ndg);
    self.gettingDurations = true;
    $simulationService
      .getPriceListDurations(ndg)
      .then(function (response) {
        if (response.success) {
          if (response.durateListino.length) {
            console.log("Response durations: ", response);
            self.arrayOfDurations = response.durateListino;
          } else {
            self.arrayOfDurations = self.defaults.durations;
          }
        }
        self.gettingDurations = false;
      })
      .catch(function (error) {
        self.gettingDurations = false;
        console.log("ERROR", error);
      });
  };

  self.openSaveModal = function () {
    $modalService.openModal("savePriceListConfigurationModal");
  };

  $scope.$on("goBackToPriceListsInfo", function (event, data) {
    self.goBackToPriceListsInfo();
  });

  self.savePriceListChanges = function () {
    var vendorNdg = self.vendorNdg ? self.vendorNdg : "";
    self.savingChanges = true;
    $simulationService
      .savePriceList(vendorNdg)
      .then(function (response) {
        if (response.success) {
          $rootScope.$broadcast("addAlert", {
            text: "PRICELIST_SAVED",
          });
          self.getPriceListsOps();
          self.deleteNewPriceListData();
        }
        $modalService.closeModal("savePriceListConfigurationModal");
        self.savingChanges = false;
      })
      .catch(function (error) {
        $modalService.closeModal("savePriceListConfigurationModal");
        console.log("ERROR: ", error);
        self.savingChanges = false;
      });
  };

  self.openBackModal = function () {
    $modalService.openModal("backModal");
  };

  self.deleteNewPriceListData = function () {
    if (self.addPriceListMode) {
      self.priceListBands = [];
      self.arrayOfDurations = [];
      self.newListino.selectedDurations = [];
      self.newListino.ndgListino = null;
      self.newListino.nameListino = null;
      self.addPriceListMode = false;
    } else {
      self.listinoSelected.priceListSelected = null;
      self.priceListBands = [];
      self.listinoSelected.durationsSelected = [];
    }
    if (self.inputs && self.inputs.bandDetail) {
      self.inputs.bandDetail = self.defaults.band;
    }
    if (self.bandsCopy && self.bandsCopy.length) {
      self.bandsCopy.forEach(function (band) {
        band.detailSaved = false;
      });
    }
  };

  self.confirmOk = function () {
    if (self.bandsCopy) {
      var detailSaved = self.bandsCopy.every(function (band) {
        return band.detailSaved;
      });
    }
    if (self.addPriceListMode) {
      return (
        self.newListino &&
        self.newListino.nameListino &&
        self.newListino.ndgListino &&
        self.newListino.selectedDurations.length &&
        detailSaved
      );
    } else {
      return (
        self.listinoSelected &&
        self.listinoSelected.priceListSelected &&
        self.listinoSelected.priceListSelected.ndg &&
        self.listinoSelected.priceListSelected.description &&
        self.listinoSelected.durationsSelected.length &&
        detailSaved
      );
    }
  };

  // MODIFICA FASCE !

  self.openModalDeleteBand = function (index) {
    $modalService.openModal("deleteBandModal");
    self.currentBandId = index;
  };

  self.deleteBand = function () {
    // To delete priceList band
    var maxBandNumber = self.priceListBands.reduce(
      (max, band) => Math.max(max, band.numeroFascia),
      self.priceListBands[0].numeroFascia
    );
    if (self.priceListBands[self.currentBandId].numeroFascia < maxBandNumber) {
      self.priceListBands.splice(self.currentBandId, 1);
      var i = 1;
      self.priceListBands.forEach(function (band) {
        band.numeroFascia = i;
        i++;
      });
    } else {
      self.priceListBands.splice(self.currentBandId, 1);
    }
    self.currentBandId = "";
  };

  self.cloneBand = function (band, index) {
    // To clone priceList band
    var cloneBand = {};
    Object.assign(cloneBand, band);
    var maxBandNumber = self.priceListBands.reduce(
      (max, band) => Math.max(max, band.numeroFascia),
      self.priceListBands[0].numeroFascia
    );
    cloneBand.numeroFascia = maxBandNumber + 1;
    cloneBand.detailSaved = false;
    self.priceListBands.push(cloneBand);
  };

  self.modifyBandParameters = function (band, index) {
    // To modify priceList bands parameters
    if (
      (self.newListino.selectedDurations &&
        self.newListino.selectedDurations.length &&
        self.newListino.ndgListino) ||
      (self.listinoSelected.priceListSelected &&
        self.listinoSelected.durationsSelected.length)
    ) {
      self.bandsCopy = self.priceListBands;
      if (self.bandsCopy[index].detailSaved) {
        getBandDetail(index);
        return;
      }
      self.inputs.bandDetail.min = band.minimo;
      self.inputs.bandDetail.max = band.massimo;
      self.inputs.bandDetail.commissions = band.provvigioniFornitore;
      self.inputs.bandDetail.expenses = band.spese;
      self.inputs.bandDetail.bandNumber = band.numeroFascia;
      self.inputs.bandDetail.insuranceCosts = band.costoAssPerc;
      self.inputs.bandDetail.fixedCosts = band.costiFissiPerc;
      getBandDetail(index);
    } else {
      $rootScope.$broadcast("addAlert", {
        text: "NO_DURATIONS_PROVIDED",
      });
    }
  };

  var getBandDetail = function (index) {
    //Once you click on the pencil icon, to get band detail...
    self.bandsCopy[index].loading = true;
    var priceListNdg =
      self.newListino.ndgListino || self.listinoSelected.priceListSelected.ndg;
    var fascia = self.inputs.bandDetail.bandNumber;
    var durations = [];
    var durate =
      self.newListino && self.newListino.selectedDurations.length
        ? self.newListino.selectedDurations
        : self.listinoSelected.durationsSelected;
    durate.forEach(function (duration) {
      durations.push(duration.durata);
    });
    $simulationService
      .getBandDetail(priceListNdg, durations, fascia)
      .then(function (response) {
        if (response.success) {
          console.log("getBandDetail respnse---> ", response);
          self.inputs.bandDetail.financialParamsPerDuration =
            response.dettaglioDurate.sort(
              (dettaglioDurata1, dettaglioDurata2) => {
                return (
                  dettaglioDurata1.numeroCanoni - dettaglioDurata2.numeroCanoni
                );
              }
            );
          self.listiniEconomici.modifyBandMode = true;
          self.listiniEconomici.title = "LBL_INFO";
          // Below is intended to DELETE!!!!
          self.inputs.bandDetail.financialParamsPerDuration.forEach(function (
            detail
          ) {
            detail.costiFissi = detail.costiFissi;
            detail.costiAssicurativi = detail.costiAssicurativi;
            detail.tanPerc = detail.tanPerc * 100;
            detail.vrPerc = detail.vrPerc * 100;
            detail.prov = detail.prov * 100;
            detail.spreadFinalePerc =
              Math.round(detail.spreadFinalePerc * 1000) / 1000;
            detail.spreadLordoPerc =
              Math.round(detail.spreadLordoPerc * 1000) / 1000;
            detail.spreadNettoPerc =
              Math.round(detail.spreadNettoPerc * 1000) / 1000;
            detail.tassoEffettivoPerc =
              Math.round(detail.tassoEffettivoPerc * 1000) / 1000;
            detail.irs = Math.round(detail.irs * 1000) / 1000;
            detail.coeff = Math.round(detail.coeff * 1000) / 1000;
            //detail.spreadLordoPerc = detail.tanPerc - 0.8;
          });
        }
        self.bandsCopy[index].loading = false;
      })
      .catch(function (error) {
        console.log("ERROR", error);
        self.bandsCopy[index].loading = false;
      });
  };

  self.toggleAnticipatedCostFlag = function (detail) {
    // To toggle anticipated costs flag
    detail.anticipato = !detail.anticipato;
  };

  self.savePriceListBandDetail = function () {
    self.listiniEconomici.savingBandDetail = true;
    var listPriceLists = [];
    var priceList = {
      id: "",
      fasce: [],
      description: "",
    };
    var vendorNdg = self.vendorNdg ? self.vendorNdg : "";
    var fascieListino = [];
    var fasciaListino = {
      costiFissiPerc: "",
      costoAssPerc: "",
      dettagli: [],
      massimo: "",
      minimo: "",
      numeroFascia: "",
      provvigioni: "",
      spese: "",
    };
    self.inputs.bandDetail.financialParamsPerDuration.forEach(function (
      financialParam
    ) {
      financialParam.costiFissi = self.inputs.bandDetail.fixedCosts;
    });
    fasciaListino.costoAssPerc =
      self.inputs.bandDetail.financialParamsPerDuration[0].costiAssicurativi;
    fasciaListino.costoAssPerc = self.inputs.bandDetail.insuranceCosts;
    fasciaListino.spese = self.inputs.bandDetail.expenses;
    fasciaListino.massimo = self.inputs.bandDetail.max;
    fasciaListino.minimo = self.inputs.bandDetail.min;
    fasciaListino.costiFissiPerc = self.inputs.bandDetail.fixedCosts;
    fasciaListino.dettagli = self.inputs.bandDetail.financialParamsPerDuration;
    fasciaListino.numeroFascia = self.inputs.bandDetail.bandNumber;
    fasciaListino.provvigioni = self.inputs.bandDetail.commissions;
    fascieListino.push(fasciaListino);
    priceList.id =
      self.newListino.ndgListino || self.listinoSelected.priceListSelected.ndg;
    priceList.fasce = fascieListino;
    priceList.description =
      self.newListino.nameListino ||
      self.listinoSelected.priceListSelected.description;
    listPriceLists.push(priceList);
    $simulationService
      .savePriceListBandDetail(listPriceLists, vendorNdg)
      .then(function (response) {
        if (response.success) {
          self.bandsCopy[fasciaListino.numeroFascia - 1].detailSaved = true;
          updateBandsTable();
          $rootScope.$broadcast("addAlert", {
            text: "PRICELIST_BANDDETAIL_SAVED",
          });
          self.listiniEconomici.modifyBandMode = false;
          self.listiniEconomici.title = "LBL_PRICELISTS";
        } else {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_SAVING_PRICELIST_BAND",
          });
        }
        self.listiniEconomici.savingBandDetail = false;
      })
      .catch(function (error) {
        console.log("ERROR: ", error);
        self.listiniEconomici.savingBandDetail = false;
      });
  };

  var updateBandsTable = function () {
    var targetBand = self.priceListBands.find(function (band) {
      return band.numeroFascia == self.inputs.bandDetail.bandNumber;
    });
    var index = self.priceListBands.indexOf(targetBand);
    self.priceListBands[index].massimo = self.inputs.bandDetail.max;
    self.priceListBands[index].minimo = self.inputs.bandDetail.min;
    self.priceListBands[index].provvigioniFornitore =
      self.inputs.bandDetail.commissions;
    self.priceListBands[index].spese = self.inputs.bandDetail.expenses;
    console.log(
      "inputs.bandDetail.financialParamsPerDuration",
      self.inputs.bandDetail.financialParamsPerDuration
    );
  };

  self.goBackToPriceListsInfo = function () {
    if (self.listiniEconomici.modifyBandMode) {
      self.listiniEconomici.modifyBandMode = false;
      self.listiniEconomici.title = "LBL_PRICELISTS";
      self.inputs.bandDetail.min = self.defaults.band.minimo;
      self.inputs.bandDetail.max = self.defaults.band.massimo;
      self.inputs.bandDetail.commissions =
        self.defaults.band.provvigioniFornitore;
      self.inputs.bandDetail.expenses = self.defaults.band.spese;
    }
  };
}
